import { useField } from 'formik'
import React, { useEffect, useRef } from 'react'
import { Form, Label } from 'semantic-ui-react'
import Conditional from '../common/Conditional'
import FWOLabel from './FWOLabel'

interface Props {
  placeholder: string
  name: string
  type?: string
  rows: number
  label?: string
  tooltip?: string
  required: boolean
  limit: number
  showreadonly?: boolean
  clearSelection?: boolean
  showOptional?: boolean
  style?: any
}

const FWOLimitedTextAreaInput = (props: Props) => {
  const mountedRef = useRef(false)
  const [field, meta, helpers] = useField(props.name)
  const setFormattedContent = (text) => {
    if (text === undefined) {
      return
    }
    helpers.setValue(text.slice(0, props.limit))
  }
  const hasError =
    meta.touched && (field.value === null || field.value === '') && !!meta.error

  useEffect(() => {
    mountedRef.current = true
    if (
      mountedRef.current &&
      props.clearSelection !== undefined &&
      props.clearSelection === true
    ) {
      helpers.setValue('')
    }
    return () => {
      mountedRef.current = false
    }
  }, [props.clearSelection])

  return (
    <Form.Field error={hasError}>
      <FWOLabel
        label={props.label}
        name={props.name}
        tooltip={props.tooltip}
        showOptional={props.showOptional}
        required={props.required}
      />
      {hasError ? <span className="validation-error">{meta.error}</span> : null}
      <textarea
        {...field}
        {...{
          name: props.name,
          label: props.label,
          rows: props.rows,
          placeholder: props.placeholder,
          type: 'text',
        }}
        aria-label={hasError ? props.label + meta.error : props.label}
        title={`${props.tooltip == null ? '' : props.tooltip}`}
        onChange={(event) => setFormattedContent(event.target.value)}
        {...{ readOnly: props.showreadonly == true }}
        {...{ style: props.style }}
      />
      <Conditional if={!props.showreadonly}>
        <Label basic pointing>
          {`You have ${
            props.limit -
            (field.value === undefined || field.value === null
              ? 0
              : field.value.length)
          } characters remaining`}
        </Label>
      </Conditional>
    </Form.Field>
  )
}

export default FWOLimitedTextAreaInput
